import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PublicLayout from '../components/PublicLayout';
import './CommonPages.css';

const About = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const tr = i18n.language?.startsWith('tr');

  const page = tr
    ? {
        title: 'Hakkımızda',
        subtitle: 'Kurumsal erişimi sade, güvenilir ve yönetilebilir kılmak için çalışıyoruz.',
        storyTitle: 'Neden varız',
        story: 'ArcVPN, şirketlerin uzaktan ve çok lokasyonlu erişimini karmaşıklaştırmadan kurması için doğdu. Amacımız gösterişli vaatler değil; günlük operasyonda ayakta duran bir erişim katmanı.',
        valuesTitle: 'Nasıl çalışırız',
        values: [
          { title: 'Netlik', body: 'Kontroller anlaşılır olmalı. Kullanıcı da yönetici de ne olduğunu bilmeli.' },
          { title: 'Güven', body: 'Gizlilik ve erişim disiplini ürünün merkezinde; abartısız ve ölçülü.' },
          { title: 'Operasyon', body: 'Kurulum kolay, izleme yeterli, destek ulaşılabilir olmalı.' },
        ],
        timelineTitle: 'Yolculuk',
        timeline: [
          { year: 'Kuruluş', body: 'Kurumsal uzaktan erişim ihtiyacına odaklı ürün çekirdeği.' },
          { year: 'Platform', body: 'Şirket paneli, davetler, lisanslar ve bağlantı görünürlüğü.' },
          { year: 'Bugün', body: 'Düğüm yönetimi, destek süreçleri ve çok platformlu istemciler.' },
        ],
        ctaTitle: 'Birlikte bakalım',
        ctaBody: 'Ürünü denemek veya ekibiniz için konuşmak isterseniz yazın.',
      }
    : {
        title: 'About ArcVPN',
        subtitle: 'We build corporate access that stays calm, clear, and manageable.',
        storyTitle: 'Why we exist',
        story: 'ArcVPN started so companies can set up remote and multi-site access without turning it into a project graveyard. We care less about loud claims and more about an access layer that holds up in daily operations.',
        valuesTitle: 'How we work',
        values: [
          { title: 'Clarity', body: 'Controls should be understandable to both users and admins.' },
          { title: 'Trust', body: 'Privacy and access discipline sit at the center — measured, not theatrical.' },
          { title: 'Operations', body: 'Setup should be simple, visibility enough, and support reachable.' },
        ],
        timelineTitle: 'Path so far',
        timeline: [
          { year: 'Founding', body: 'Product core focused on corporate remote access.' },
          { year: 'Platform', body: 'Company console, invites, licenses, and connection visibility.' },
          { year: 'Today', body: 'Node management, support workflows, and multi-platform clients.' },
        ],
        ctaTitle: 'Let’s talk',
        ctaBody: 'Try the product or reach out if you want a fit check for your team.',
      };

  return (
    <PublicLayout title={page.title} subtitle={page.subtitle}>
      <div className="common-page">
        <section className="arc-panel about-story">
          <h2>{page.storyTitle}</h2>
          <p>{page.story}</p>
        </section>

        <section className="arc-section">
          <div className="arc-section-head">
            <h2>{page.valuesTitle}</h2>
          </div>
          <div className="arc-grid-3">
            {page.values.map((value) => (
              <article className="arc-panel" key={value.title}>
                <h3>{value.title}</h3>
                <p>{value.body}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="arc-section">
          <div className="arc-section-head">
            <h2>{page.timelineTitle}</h2>
          </div>
          <div className="about-timeline">
            {page.timeline.map((item) => (
              <article key={item.year}>
                <h3>{item.year}</h3>
                <p>{item.body}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="arc-cta-band">
          <h2>{page.ctaTitle}</h2>
          <p>{page.ctaBody}</p>
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
            <button type="button" className="arc-btn arc-btn-solid" onClick={() => navigate('/signup')}>
              {tr ? 'Dene' : 'Try it'}
            </button>
            <button type="button" className="arc-btn arc-btn-ghost" onClick={() => navigate('/contact')}>
              {tr ? 'İletişim' : 'Contact'}
            </button>
          </div>
        </section>
      </div>
    </PublicLayout>
  );
};

export default About;
